import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Artwork } from '@definitions/artworks.types';
import { ArtworkList } from '@components/artworkList';

import { Container, Title, ArtworksContainer, imageStyles } from './recommendedArtworks.styles';

export interface RecommendedArtworksProps {
  artworks: Artwork[];
}

export const RecommendedArtworks = ({ artworks }: RecommendedArtworksProps) => (
  <Container>
    <Title>
      <FormattedMessage id="recommendedArtworks.title" defaultMessage="Recommended:" />
    </Title>
    <ArtworksContainer>
      <ArtworkList artworks={artworks} imageStyles={imageStyles} />
    </ArtworksContainer>
  </Container>
);
